export default __webpack_public_path__ + "static/media/downJoystickArrow.e19b1476.svg";